export default __webpack_public_path__ + "static/media/FienLovelace.efca0305.png";